import { connect } from 'react-redux';
import {
  getEventExecutionEvents,
  getEventsExecuteTime,
  getEventsOptions,
  getLabels,
  getMetainf,
  getProjectOriginalZoneId,
  getProjectZoneId,
  getLocation,
} from '../../reducers/analyticsApp';
import {
  changeEventChartMode,
  changeEventView,
  changeVisibleFormula,
  enterFormula,
  setEventColumnChartSorting,
  toggleAdaptive,
  toggleAverageLine,
  toggleCalcTotal,
  toggleCumulative,
  toggleMedianLine,
  toggleTrendLine,
} from '../../actions/events/events';
import {
  changeAdaptive,
  changeCumulative,
  onChangeSorting,
  toggleAverage,
  toggleGrandTotal,
  toggleMedian,
  toggleTrend,
} from '../../actions/chart';
import PresentationComponent from '../../components/event/Result';

const mapStateToProps = (state) => {
  return {
    result: getEventExecutionEvents(state) || [],
    executeTime: getEventsExecuteTime(state),
    timezone: getProjectZoneId(state),

    metainf: getMetainf(state),
    executionEvents: getEventExecutionEvents(state),

    options: getEventsOptions(state),

    originalZoneId: getProjectOriginalZoneId(state),
    zoneId: getProjectZoneId(state),
    labels: getLabels(state),

    location: getLocation(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onChangeView: (view) => dispatch(changeEventView(view)),
  onChangeChartMode: (single) => dispatch(changeEventChartMode(single)),
  onChangeVisibleFormula: () => dispatch(changeVisibleFormula()),
  enterFormula: (formula) => dispatch(enterFormula(formula)),

  onChangeSorting: (sorting) =>
    onChangeSorting(sorting, () => dispatch(setEventColumnChartSorting(sorting))),
  toggleGrandTotal: (e, columnChartSorting) =>
    toggleGrandTotal(e, columnChartSorting, () => dispatch(toggleCalcTotal())),
  toggleTrendLine: (e) => toggleTrend(e, () => dispatch(toggleTrendLine())),
  toggleAverageLine: (e) => toggleAverage(e, () => dispatch(toggleAverageLine())),
  toggleMedianLine: (e) => toggleMedian(e, () => dispatch(toggleMedianLine())),
  toggleAdaptive: (e) => changeAdaptive(e, () => dispatch(toggleAdaptive())),
  toggleCumulative: (e) => changeCumulative(e, () => dispatch(toggleCumulative())),
});

const Result = connect(mapStateToProps, mapDispatchToProps)(PresentationComponent);

export default Result;
